import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const createMembers = async (data) => {
  return await axios.post('members', data)
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default createMembers;